<form [formGroup]="normaalTariefFg">
  <ng-container formArrayName="aanmerkelijkBelangHouders">
    <ng-container *ngFor="let item of aanmerkelijkBelangHouders.controls; let i = index; trackBy: trackByFn"
                  [formGroupName]="i">
      <div class="row mb-0.5">
        <div class="col-auto">
          <snelstart-ui-text-form-control (change)="this.saveForm()"
                                          [label]="i === 0 ? 'Naam aandeelhouder' : ''"
                                          [required]=true
                                          class="custom-input-250"
                                          formControlName="naamGerechtigde"
                                          id="naamGerechtigde"
          >
          </snelstart-ui-text-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-bsn-form-control (change)="this.saveForm()"
                                         [label]="i === 0 ? 'Fiscaal nummer' : ''"
                                         class="custom-input-150"
                                         formControlName="fiscaalNummerGerechtigde"
                                         id="fiscaalNummerGerechtigde2"
          >
          </snelstart-ui-bsn-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-number-form-control (change)="this.saveForm()"
                                            [label]="i === 0 ? 'Percentage aandelen' : ''"
                                            [minValue]="0"
                                            [showAllDecimals]="true"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="percentageBelang"
                                            prefix="%"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-number-form-control (change)="this.saveForm()"
                                            [label]="i === 0 ? 'Bedrag dividend' : ''"
                                            [minValue]="0"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="dividendGerechtigde"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-button (click)="verwijderRij(i)"
                               [class]="i === 0 ? 'firstrowbutton' : ''"
                               icon="trash"
                               iconType="light"
                               id="buttonDelete"
                               size="medium"
                               type="secondary"
          >
          </snelstart-ui-button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</form>

<div *ngIf="aanmerkelijkBelangHouders.length === 0">
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancelA"
                       type="link">Aandeelhouder invullen
  </snelstart-ui-button>
</div>
<div *ngIf="aanmerkelijkBelangHouders.length > 0">
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancelB"
                       type="link">Aandeelhouder toevoegen
  </snelstart-ui-button>
</div>

<div *ngIf="this.totaalPercentageBelang > 100" style="width: 50%">
  <snelstart-ui-alert [showIcon]="false" type="warning">
    <b>Let op! </b> Het totaal van de percentages aandelen is {{ this.totaalPercentageBelang }}% en dus meer dan 100%!
  </snelstart-ui-alert>
</div>


